export default "__VITE_ASSET__1968f764__"